// extracted by mini-css-extract-plugin
module.exports = {"tipText":"grouping-form_tipText_FR1Fv","row":"grouping-form_row_3x8ry","btn":"grouping-form_btn_2NWt4","selectList":"grouping-form_selectList_26H4M"};